var e="__vercel_toolbar";function o(){return typeof window>"u"?void 0:window[e]}export{e as a,o as b};
